module.exports = "/_next/static/images/PartnerSignup-2eb3a0d757ab46136af5aafa82e8b6ad.jpg";